import { MoreVertical, Download, ExternalLink } from "lucide-react";
import { Dropdown } from "@/components/ui";
import { useTranslation } from "@audit-app/utils";

interface ReportRowMenuProps {
  hasPdf: boolean;
  onDownload: () => void;
  onViewAudit: () => void;
}

export function ReportRowMenu({
  hasPdf,
  onDownload,
  onViewAudit,
}: ReportRowMenuProps) {
  const { t } = useTranslation(["reports"]);
  return (
    <Dropdown>
      <Dropdown.Trigger>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className="flex items-center justify-center w-11 h-11 rounded-lg hover:bg-card-hover transition-colors"
          aria-label="Report actions"
        >
          <MoreVertical size={20} className="text-secondary" />
        </button>
      </Dropdown.Trigger>

      <Dropdown.Content align="end" side="bottom">
        <Dropdown.Item
          onSelect={onDownload}
          icon={<Download size={16} />}
          disabled={!hasPdf}
        >
          {t("reports:list.rowMenu.download")}
        </Dropdown.Item>

        <Dropdown.Item onSelect={onViewAudit} icon={<ExternalLink size={16} />}>
          {t("reports:list.rowMenu.viewAudit")}
        </Dropdown.Item>
      </Dropdown.Content>
    </Dropdown>
  );
}
